import { render, staticRenderFns } from "./ClockSvg.vue?vue&type=template&id=cd1c8d62&"
import script from "./ClockSvg.vue?vue&type=script&lang=js&"
export * from "./ClockSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports